import { render, staticRenderFns } from "./BirthdatePicker.vue?vue&type=template&id=6bda0a99&scoped=true&"
import script from "./BirthdatePicker.vue?vue&type=script&lang=js&"
export * from "./BirthdatePicker.vue?vue&type=script&lang=js&"
import style0 from "./BirthdatePicker.vue?vue&type=style&index=0&id=6bda0a99&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bda0a99",
  null
  
)

export default component.exports